import { render } from "./units.vue?vue&type=template&id=32997028"
import script from "./units.vue?vue&type=script&lang=js"
export * from "./units.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__